{
  "explorerCta": {
    "eyebrow": "<dec></dec> Explorer",
    "title": "Scopri i benefici del modello utilizzando <dec></dec> Explorer",
    "body": "Quantifica in 3 semplici passi i risultati che puoi ottenere adottando la soluzione di DEC Energy:",
    "steps": [
      "Scegli un impianto tra quelli disponibili",
      "Inserisci il target di produzione rinnovabile",
      "Ottieni subito un'analisi quantitativa"
    ],
    "cta": "Utilizza DEC Explorer",
    "plantLabel": "Impianto per questo caso"
  },
  "explorer": {
    "location": "Località",
    "peakPower": "Potenza di picco",
    "annualProduction": "Produzione annua",
    "revenue": "Reddito"
  },
  "conformita": {
    "aside": {
      "note": "Conformità SBTi · 10 anni",
      "metric": "-20 €/MWh",
      "label": "costo Garanzia di Origine"
    },
    "hero": {
      "eyebrow": "Conformità future-proof e profittevole",
      "title": "Trasforma il costo della conformità",
      "highlight": "in ricavi operativi ricorrenti",
      "subtitle": "Contrattualizzando impianti con DEC Energy ti assicuri la produzione di Garanzie di Origine della massima qualità. Inoltre ricevi una quota dei ricavi ricorrenti che rende la tua conformità redditizia."
    },
    "sbti": {
      "steps": [
        {
          "e": "Normative sempre più rigide",
          "t": "Gli standard di sostenibilità richiederanno sforzi sempre maggiori",
          "d": "Ogni nuova versione di SBTi comporta requisiti di corrispondenza temporale, coerenza geografica e tracciabilità sempre più granulari."
        },
        {
          "e": "Aumento dei costi",
          "t": "Il prezzo delle Garanzie di Origine di alta qualità aumenta",
          "d": "Confermare il posizionamento aziendale ESG-compliant sarà maggiormente complicato e sempre più costoso."
        },
        {
          "e": "Elimina il costo",
          "t": "Produci le tue Garanzie di Origine anziché acquistarle",
          "d": "Sigla contratti pluriennali su specifici impianti rinnovabili SBTi-compliant e ricevi gratuitamente le Garanzie di Origine prodotte dall’impianto stesso ogni anno."
        },
        {
          "e": "Compliance profittevole con DEC Energy",
          "t": "Ricevi una quota dei ricavi e trasforma il costo di conformità in un guadagno",
          "d": "Ottieni una quota dei ricavi derivanti dall’energia prodotta e venduta dall’impianto contrattualizzato. Il prezzo effettivo della Garanzia di Origine diventa negativo."
        }
      ],
      "chart": {
        "caption": "Prezzo della GO conforme, versione dopo versione",
        "market": "Prezzo GO conforme SBTi",
        "without": "GO senza DEC Energy",
        "with": "GO con DEC Energy",
        "matching": "Corrispondenza temporale e geografica:",
        "time": "TEMPO",
        "zeroed": "costo GO azzerato",
        "aria": "Curva del costo di conformità: cresce man mano che lo standard si irrigidisce, dalle fasce meno stringenti a quelle più stringenti."
      }
    },
    "proof": [
      {
        "prefix": "fino a",
        "target": "− 20",
        "suffix": "€/MWh",
        "label": "di costo negativo per la Garanzia di Origine"
      },
      {
        "target": 10,
        "suffix": "anni",
        "label": "di impegno su impianti identificati"
      },
      {
        "target": 100,
        "suffix": "%",
        "label": "della produzione tracciata e verificabile"
      }
    ],
    "story": {
      "heading": "Un esempio concreto di conformità future-proof e profittevole",
      "cards": [
        {
          "title": "Azienda packaging si garantisce conformità decennale a SBTi v2 con DEC Energy",
          "body": "Un'azienda europea del packaging contrattualizza un impianto fotovoltaico per 10 anni. I suoi committenti chiedono standard di sostenibilità lungo la filiera e la conformità va dimostrata anno per anno. Adottando la soluzione di DEC Energy, l'azienda, soggetta a SBTi, trasforma il costo della conformità in un profitto ricorrente.",
          "metrics": [
            {
              "value": "- 13 €/MWh",
              "label": "costo GO annuo negativo"
            },
            {
              "value": "SBTi",
              "label": "GO SBTi compliant"
            }
          ]
        }
      ]
    }
  },
  "copertura-naturale": {
    "aside": {
      "note": "Prezzo coperto, senza derivati",
      "metric": "45-70%",
      "label": "oscillazione assorbita"
    },
    "hero": {
      "eyebrow": "Riduci la volatilità dei costi energetici",
      "title": "Neutralizza le oscillazioni del tuo costo energetico per i",
      "highlight": "prossimi 10 anni",
      "subtitle": "Riduci la volatilità dei costi dell’energia ottenendo una quota dei ricavi correlata al prezzo di mercato dell’elettricità. Continua a comprare energia dalla rete, senza toccare la fornitura e senza derivati."
    },
    "hedge": {
      "steps": [
        {
          "e": "La volatilità dei prezzi",
          "t": "Il tuo costo elettrico è volatile e imprevedibile",
          "d": "Le oscillazioni dei prezzi di mercato dell’elettricità rendono la spesa per l’approvvigionamento energetico difficile da stimare"
        },
        {
          "e": "Quota dei ricavi dall’energia",
          "t": "Guadagni dall’energia prodotta e venduta dall’impianto",
          "d": "Sigla un accordo pluriennale su impianti rinnovabili e ti garantisci una quota dei ricavi generati dagli stessi. Questi ricavi, essendo correlati ai tuoi costi energetici, ne rappresentano una copertura naturale."
        },
        {
          "e": "Il tuo costo netto",
          "t": "Gli aumenti della bolletta sono compensati dai profitti",
          "d": "Quando i tuoi costi energetici crescono, aumenta anche la quota dei ricavi generati dall’impianto, e viceversa."
        },
        {
          "e": "Volatilità neutralizzata",
          "t": "Il risultato: costi stabili per 10 anni",
          "d": "Ti garantisci una riduzione delle oscillazioni dei tuoi costi energetici per l’intera durata contrattuale. Il risultato si somma ad eventuali coperture già esistenti. Nessun rischio volume."
        }
      ],
      "chart": {
        "spend": "Spesa energia",
        "revenue": "Ricavi impianti",
        "net": "Costo netto",
        "year": "ANNO",
        "aria": "Spesa energia, ricavi dagli impianti e costo netto su dieci anni"
      }
    },
    "proof": [
      {
        "target": "45-70",
        "suffix": "%",
        "label": "di riduzione delle oscillazioni"
      },
      {
        "target": 100,
        "suffix": "%",
        "label": "flessibilità sulla fornitura, che resta invariata"
      },
      {
        "target": 10,
        "label": "anni di copertura dalla volatilità"
      }
    ],
    "story": {
      "heading": "Un caso concreto di riduzione della volatilità dei prezzi energetici",
      "cards": [
        {
          "title": "Azienda dell'industria alimentare riduce la volatilità dei costi energetici con DEC Energy",
          "body": "Un'azienda leader dell'industria alimentare italiana contrattualizza un asset fotovoltaico che vende l'energia prodotta al prezzo di mercato. Il contratto si aggiunge alle coperture già attive e l'oscillazione residua sul costo netto si riduce sensibilmente.",
          "metrics": [
            {
              "value": "-12.41%",
              "label": "riduzione volatilità nello scenario di costi energetici stabili"
            },
            {
              "value": "-27.94%",
              "label": "riduzione volatilità nello scenario di costi energetici incerti"
            }
          ]
        }
      ]
    }
  },
  "ebitda": {
    "aside": {
      "note": "Aumento EBITDA · 10 anni",
      "metric": "20k €/GWh",
      "label": "margine operativo annuo"
    },
    "chart": {
      "goSaving": "Risparmio GO",
      "energyRevenue": "Ricavi energia",
      "now": "EBITDA attuale",
      "withDec": "EBITDA con DEC Energy",
      "withDecShort": "EBITDA con",
      "title": "EBITDA: effetto DEC Energy"
    },
    "hero": {
      "eyebrow": "Migliora la tua redditività operativa",
      "title": "",
      "highlight": "Migliora l’EBITDA",
      "titleEnd": "riducendo i tuoi costi energetici in maniera prevedibile",
      "subtitle": "Contrattualizzando impianti con DEC Energy elimini il costo per le Garanzie di Origine e ricevi ricavi operativi ricorrenti. Fino a +20k € di aumento EBITDA per ogni GWh contrattualizzato.",
      "note": "Secondo i principi contabili internazionali IAS/IFRS, l'operazione DEC Energy incrementa l'EBITDA."
    },
    "pnl": {
      "steps": [
        {
          "e": "L’EBITDA attuale",
          "t": "Il costo dell’energia rinnovabile riduce il tuo EBITDA",
          "d": "L'acquisto delle Garanzie di Origine è una riga di costo operativo ricorrente e volatile."
        },
        {
          "e": "Primo effetto positivo su EBITDA",
          "t": "Elimina la spesa per le Garanzie di Origine, migliora l’EBITDA",
          "d": "Le Garanzie di Origine prodotte dall’impianto contrattualizzato ti vengono distribuite gratuitamente ogni anno, eliminando il costo operativo volatile e ricorrente che rappresentano."
        },
        {
          "e": "Secondo effetto positivo su EBITDA",
          "t": "Altri Ricavi Operativi ad incremento dell’EBITDA",
          "d": "Siglando un accordo pluriennale, ti garantisci una quota ricorrente dei ricavi derivanti dall’energia prodotta e venduta dall’impianto. La quota si configura come altro ricavo operativo."
        },
        {
          "e": "L’EBITDA con DEC Energy",
          "t": "Il risultato: stessa energia, EBITDA più alto",
          "d": "L’adozione della soluzione DEC Energy aumenta la redditività operativa. L'effetto netto sull'EBITDA è positivo e strutturale per tutta la durata del contratto."
        }
      ]
    },
    "proof": [
      {
        "prefix": "fino a",
        "target": "+ 20k",
        "suffix": "€",
        "label": "di effetto sull'EBITDA per GWh consumato"
      },
      {
        "target": 2,
        "label": "effetti distinti e positivi su EBITDA"
      },
      {
        "target": 10,
        "suffix": "anni",
        "label": "di ricavi operativi ricorrenti"
      }
    ],
    "story": {
      "heading": "Un esempio concreto di miglioramento della redditività operativa",
      "cards": [
        {
          "title": "Cartiera parte di un fondo di Private Equity migliora l'EBITDA con DEC Energy",
          "body": "Leader europeo nell'industria cartaria controllato da un fondo di Private Equity, migliora il proprio EBITDA siglando un contratto decennale su un impianto da 7.2 MWp con DEC Energy. L'accordo si aggiunge alla fornitura di energia esistente senza sostituirla e genera un effetto strutturale positivo sull'EBITDA.",
          "metrics": [
            {
              "value": "+ 320 k€",
              "label": "di EBITDA annuo a regime"
            },
            {
              "value": "+20k €/GWh",
              "label": "di EBITDA per GWh consumato"
            }
          ]
        }
      ]
    }
  },
  "impatto": {
    "aside": {
      "note": "Impatto pubblico e verificabile",
      "metric": "2'500 tCO₂",
      "label": "emissioni evitate, sulla mappa"
    },
    "plantAlt": "Impianto agrivoltaico: pannelli solari sopra le colture",
    "hero": {
      "eyebrow": "Transizione energetica raccontabile",
      "title": "Eleva la tua transizione energetica con una soluzione",
      "highlight": "concreta e comunicabile",
      "subtitle": "Contrattualizza specifici impianti rinnovabili e supporta la transizione energetica con un commitment di lungo periodo. Genera un impatto ambientale e sociale positivo sul territorio."
    },
    "profile": {
      "steps": [
        {
          "e": "Un pubblico sempre più attento",
          "t": "Dimostrare la tua sostenibilità richiederà un impegno crescente",
          "d": "I tuoi ambiziosi obiettivi di sostenibilità generano un'aspettativa sempre maggiore che presuppone l'utilizzo di strumenti capaci di creare impatto concreto e comunicabile"
        },
        {
          "e": "Una soluzione in più per la tua sostenibilità",
          "t": "Supporta la generazione di nuova energia rinnovabile",
          "d": "Contribuisci attivamente alla transizione energetica siglando accordi pluriennali su specifici impianti rinnovabili. Sostieni la produzione locale di energia pulita e ricevi i tuoi certificati GO."
        },
        {
          "e": "Un impegno che va oltre all'energia",
          "t": "Il connubio tra impatto ambientale e sociale",
          "d": "Contrattualizza impianti che, oltre a permetterti di raggiungere i tuoi obiettivi di energia rinnovabile, creano un forte valore a sostegno delle persone e della natura."
        },
        {
          "e": "Il tuo profilo pubblico",
          "t": "Condividi il tuo impegno concreto con gli stakeholders",
          "d": "Un modello virtuoso e replicabile, capace di coinvolgere il tuo pubblico attraverso una pagina condivisibile, trasparente e interattiva."
        }
      ],
      "card": {
        "url1": "agrivoltaico-cascina-nuova",
        "url2": "la-tua-azienda",
        "company": "La tua azienda",
        "companyTag": "Profilo d'impatto · pubblico",
        "verified": "Verificato DEC Energy",
        "stats": ["MWh rinnovabili quest'anno", "CO₂ evitata", "GO cancellate"],
        "contractLabel": "Accordo pluriennale",
        "contractMeta": "Agrivoltaico Cascina Nuova · 4.75 MWp",
        "go": "Garanzie di Origine",
        "revenue": "€ ricavi ricorrenti",
        "plantName": "Agrivoltaico Cascina Nuova",
        "plantMeta": "Vigevano (PV) · 4.75 MWp · pagina pubblica",
        "props": [
          { "t": "raccolto protetto", "v": "grandine e calore" },
          { "t": "consumo d'acqua", "v": "− 12'400 m³/anno" },
          { "t": "resa agricola", "v": "+ 20%" }
        ],
        "backed": "sostenuto dalla tua azienda",
        "foot": "Un link per dimostrarlo a chiunque, a costo GO zero,",
        "footEmph": "con ricavi",
        "reportTitle": "Report di Sostenibilità",
        "dials": ["quota rinnovabile", "emissioni", "stakeholder"],
        "mapPlants": "impianti",
        "mapRegions": "regioni",
        "mapAria": "Mappa del Centro-Nord Italia con tre impianti contrattualizzati."
      }
    },
    "proof": [
      {
        "target": 15,
        "suffix": "min",
        "label": "granularità della produzione in tempo reale"
      },
      {
        "target": 280,
        "suffix": "tCO₂",
        "label": "di emissioni evitate per ogni GWh prodotto"
      },
      {
        "target": 10,
        "suffix": "anni",
        "label": "di impegno a supporto della transizione energetica"
      }
    ],
    "story": {
      "heading": "Un esempio concreto di sostenibilità sul territorio",
      "cards": [
        {
          "title": "BancaStato avanza concretamente sul fronte energetico con DEC Energy",
          "body": "BancaStato ha adottato una strategia di sostenibilità che tocca tutti gli ambiti della propria attività. Nell'ambito energetico, la Banca cercava un'ulteriore soluzione che completasse le attuali iniziative e che permettesse di avanzare concretamente sul fronte energetico. Senza compromessi tra impatto e redditività.",
          "metrics": [],
          "quote": {
            "text": "Con questa iniziativa intendiamo contribuire a valorizzare l'integrazione degli aspetti di sostenibilità nell'ambito delle decisioni finanziarie aziendali.",
            "attribution": "Luca Bordonzotti, manager della sostenibilità di BancaStato"
          }
        }
      ]
    }
  },
  "riduzione-prevedibile": {
    "aside": {
      "note": "Costo ridotto · 10 anni",
      "metric": "− 24.7%",
      "label": "costo dell'energia"
    },
    "chart": {
      "title": "Da dove arriva la riduzione",
      "totalCosts": "Costi energetici complessivi",
      "goValue": "Controvalore GO",
      "revenueShare": "Quota dei ricavi dell'energia venduta",
      "netCost": "Costo energetico netto",
      "goCost": "Costo GO",
      "energyCost": "Costo energia",
      "withDec": "con DEC Energy"
    },
    "hero": {
      "eyebrow": "Riduzione prevedibile dei costi energetici",
      "title": "Riduci ulteriormente i tuoi costi energetici",
      "highlight": "in modo prevedibile",
      "subtitle": "Contrattualizzando impianti con DEC Energy, incassi una quota dei ricavi dell’energia venduta e ricevi Garanzie di Origine (GO). Ottieni così un doppio effetto di riduzione dei tuoi attuali costi energetici: la quota dei ricavi compensa il costo della bolletta, le GO evitano una spesa."
    },
    "bars": {
      "steps": [
        {
          "e": "Il costo attuale",
          "t": "Oggi l’energia rinnovabile rappresenta una doppia voce di costo",
          "d": "L’acquisto dell’energia e delle Garanzie di Origine comporta una spesa ricorrente che ogni consumatore di energia rinnovabile deve sostenere."
        },
        {
          "e": "Elimina la spesa",
          "t": "Con DEC Energy annulli il costo delle Garanzie di Origine",
          "d": "Produci le tue Garanzie di Origine in maniera passiva contrattualizzando specifici impianti rinnovabili. Le GO verranno distribuite e cancellate a nome della tua azienda. Non devi più spendere per acquistarle."
        },
        {
          "e": "Incassa i profitti",
          "t": "Ottieni inoltre una quota dei ricavi ricorrenti e prevedibili",
          "d": "Incassa una quota dei ricavi dell’energia prodotta e venduta dall’impianto che hai contrattualizzato. In questo modo, ti garantisci un ricavo ricorrente per l’intera durata dell’accordo."
        },
        {
          "e": "Il costo netto con DEC Energy",
          "t": "Il risultato: la spesa energetica netta si riduce",
          "d": "Il risparmio sulle GO e la quota dei ricavi derivanti dalla vendita dell’energia riducono fino al 25% il tuo costo energetico attuale. Senza cambiare i tuoi contratti di fornitura energetica attivi."
        }
      ]
    },
    "proof": [
      {
        "prefix": "fino a",
        "target": 25,
        "suffix": "%",
        "label": "di riduzione dei costi energetici"
      },
      {
        "target": 100,
        "suffix": "%",
        "label": "libertà di scelta della fornitura energetica"
      },
      {
        "target": 1,
        "suffix": "GWh",
        "label": "volume minimo di energia contrattualizzabile"
      }
    ],
    "story": {
      "heading": "Un esempio concreto di riduzione prevedibile dei costi energetici",
      "cards": [
        {
          "title": "Azienda siderurgica riduce i suoi costi energetici del {24.7%} con DEC Energy",
          "body": "Uno dei principali gruppi siderurgici europei contrattualizza 14.4 GWh/anno di produzione fotovoltaica attraverso il modello DEC Energy. Il contratto si aggiunge alla fornitura esistente senza sostituirla, garantendo un risparmio prevedibile sui costi energetici per i prossimi 15 anni.",
          "metrics": [
            {
              "value": "≈ 263 k€",
              "label": "beneficio operativo annuo a regime, EBITDA view"
            },
            {
              "value": "− 24.7%",
              "label": "costo dell'energia rinnovabile su 15 anni"
            }
          ]
        }
      ]
    }
  }
}
